import React from 'react';
import { $router, ReactRouter } from 'src/react-router/Index';
import {Iroutes} from "../react-router/types";
import useRedux from "../hooks/useRedux";

const Home = () => import(/* webpackChunkName: "index" */"src/pages/home/Home");
const Pledge = () => import(/* webpackChunkName: "pledge" */"src/pages/pledge/Pledge");
const Trade = () => import(/* webpackChunkName: "trade" */"src/pages/trade/Index");

export default function RouterView() {
    const { storeData } = useRedux();

    const routes: Iroutes[] = [
        {
            path: "/",
            component: Home,
            exact: true
        },
        {
            path: "/pledge",
            component: Pledge
        },
        {
            path: "/trade",
            component: Trade,
            beforeRender() {
                return new Promise<void>((resolve, reject) => {
                  if (storeData.address && storeData.isAdmin) {
                    resolve();
                  } else {
                    $router.goback();
                    reject()
                  }
                  // resolve();
                });
            }
        }
        /*ExplorerRoutes,*/
    ];

    return (
        <ReactRouter routes={routes} />
    )
}
